module.exports = require("./ms-SG.d.ts");